const Theme = {
  body_background_color: '#e2f2f8',

  header_full_height: true,

  logo_image_url: 'fouillespc.png',

  token_url: 'fouillespc.png',
  token_width: 50,
  number_hidden: true,

  button_color: '#00447b',

  text_font: `Georgia, serif`,
  text_size: 18,
  title_font: `Helvetica, sans-serif`,
  title_size: 28,
}

export default Theme
